import Lottie from 'lottie-react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../shared/components/Buttons';

const ErrorPage404 = () => {
  const [animationData, setAnimationData] = useState<object | null>(null);
  const navigate = useNavigate();

  // Lazy load animation only when offline
  useEffect(() => {
    if (!animationData) {
      import('../../../public/assets/lottie/error404Animations.json')
        .then((module) => setAnimationData(module.default))
        .catch((error) =>
          console.error('Failed to load no-internet animation:', error)
        );
    }
  }, [animationData]);
  return (
    <div className="flex flex-col items-center justify-center w-screen h-screen bg-gray-50">
      {animationData ? (
        <Lottie
          animationData={animationData}
          loop
          style={{
            height: '50%',
            width: '50.5%', // Maintains 160:128 ratio (5:4) - width = height * 1.25
            aspectRatio: '5/4',
          }}
        />
      ) : (
        <div className="flex items-center justify-center">
          <div className="text-gray-400">Ładowanie...</div>
        </div>
      )}
      <div className="flex flex-col items-center justify-center gap-5">
        <div className="flex flex-col items-center justify-center gap-1">
          <p className="text-titleMedium text-on-surface-variant">
            Page not found
          </p>
          <div className="flex flex-col items-center justify-center">
            <p className="text-bodyLarge text-on-surface-variant">
              The page you are looking for doesn’t exist or may have been moved.
            </p>
            <p className="text-bodyLarge text-on-surface-variant">
              Please check the URL or go back to continue.
            </p>
          </div>
        </div>
        <Button
          className="cursor-pointer"
          label="Go back"
          onClick={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default ErrorPage404;
